import { Draggable } from 'react-beautiful-dnd';
import gettext from '@sdk/lang/gettext';
import { useFormContext } from 'react-hook-form';

import {
  CheckboxMock,
  RemoveSubtaskButton,
  SubtaskContainer,
  SubtaskField,
} from './draggableSubtask.styles';

type Props = {
  canRemove: boolean;
  formFieldId: string;
  index: number;
  removeSubtask: (index: number) => void;
};

export const DraggableSubtask = ({ canRemove, formFieldId, index, removeSubtask }: Props) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const watchIsDeleted = watch(`subtasks.${index}.isDeleted`, false);
  if (watchIsDeleted) {
    return null;
  }

  return (
    <Draggable draggableId={formFieldId} index={index}>
      {(dragProvided) => (
        <SubtaskContainer
          {...dragProvided.dragHandleProps}
          {...dragProvided.draggableProps}
          ref={dragProvided.innerRef}>
          <CheckboxMock size={16} />
          <SubtaskField
            {...register(`subtasks.${index}.title`)}
            id={formFieldId}
            maxLength={256}
            placeholder={gettext('Add a subtask')}
            invalid={Boolean(errors.subtasks)}
          />

          {canRemove && <RemoveSubtaskButton onClick={() => removeSubtask(index)} />}
        </SubtaskContainer>
      )}
    </Draggable>
  );
};
